import { buildCoverSheetConfig } from '../shared';
import { BaseListingConfig, type ListingLocaleOverrides } from './base';
import { overrides } from './overrides';

/**
 * Builds the coversheet config for a listing.
 * @param locale Locale code, e.g. CA
 * @returns Coversheet config for specified locale
 */
export function buildListingCoverSheetConfig(locale: string) {
  const localeOverrides: ListingLocaleOverrides = overrides[locale] ?? {
    locale,
  };
  return buildCoverSheetConfig(BaseListingConfig, localeOverrides);
}
